import { render, staticRenderFns } from "./priceListReport.vue?vue&type=template&id=84b83c0a&"
import script from "./priceListReport.vue?vue&type=script&lang=js&"
export * from "./priceListReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports